"use strict";
const { NUMBER } = require('../../../definitions/operandValueTypes');
exports.accepts = ({ valueType }) => valueType === NUMBER;
exports.parse = ({ value }) => {
    // Parsing string to integer. See here for performance of `value * 1`:
    // https://flaviocopes.com/how-to-convert-string-to-number-javascript
    // returns NaN if conversion failed
    const parsedValue = value * 1;
    return parsedValue;
};
//# sourceMappingURL=numberParser.js.map